import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, retry } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { URLS } from 'src/app/core/constants/ConstantVariables';
import { Environment } from 'src/app/environment/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GenericService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private authService = inject(AuthService);

  URLS: typeof URLS = URLS;
  private baseUrl: string;
  // private baseUrlSSORedirect: string;
  public environment: Environment = new Environment();

  private requestStartSubject = new Subject<void>();

  private requestCompleteSubject = new Subject<void>();


  public getRequestStartObservable() {
    return this.requestStartSubject.asObservable();
  }

  public getRequestCompleteObservable() {
    return this.requestCompleteSubject.asObservable();
  }

  constructor() {
    this.baseUrl = this.environment.getApiConnection() + 'api/v1/';
  }

  public getData(url: string, completeURLProvided: boolean = false, headers?: HttpHeaders) {
    url = completeURLProvided ? url : this.baseUrl + url;

    return this.http.get<any>(url, headers ? { headers } : {}).pipe(
      tap(
        (data: any) => {},
        (error) => {
          if (error.status == 401) {
          } else {
            return error;
          }
        }
      )
    );
  }

  public postData<T>(url: string, data: any) {
    return this.http.post<T>(this.baseUrl + url, data).pipe(
      tap(
        (data) => {
          return data;
        },
        (error) => {
          if (error.status == 401) {
            this.authService.LogOut();
          } else {
            return error;
          }
        }
      )
    );
  }


  public postDataFileUpload<T>(url: string, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        accept: 'text/plain; x-api-version=1.0',
        'Content-Type': 'multipart/form-data',
      }),
    };

    return this.http.post<T>(this.baseUrl + url, data, httpOptions).pipe(
      tap(
        (data) => {
          return data;
        },
        (error) => {
          if (error.status == 401) {
            this.authService.LogOut();
          } else {
            return error;
          }
        }
      )
    );
  }

  public putData<T>(url: string, data: any) {
    return this.http.put<T>(this.baseUrl + url, data).pipe(
      tap(
        (data) => {
          return data;
        },
        (error) => {
          if (error.status == 401) {
            this.authService.LogOut();
          } else {
            return error;
          }
        }
      )
    );
  }

  public patchData<T>(url: string, data: any) {
    return this.http.patch<T>(this.baseUrl + url, data).pipe(
      tap(
        (data) => {
          return data;
        },
        (error) => {
          if (error.status == 401) {
            this.authService.LogOut();
          } else {
            return error;
          }
        }
      )
    );
  }

  public deleteData<T>(url: string) {
    return this.http.delete<T>(this.baseUrl + url).pipe(
      tap(
        (data) => {
          return data;
        },
        (error) => {
          if (error.status == 401) {
            this.authService.LogOut();
          } else {
            return error;
          }
        }
      )
    );
  }
  public getText(url: string, completeURLProvided: boolean = false, options: any = {}) {
    url = completeURLProvided ? url : this.baseUrl + url;

    return this.http.get(url, { ...options }).pipe(
      tap(
        (data) => { },
        (error) => {
          if (error.status == 401) {

          }
          return error;
        }
      )
    );
  }
}
